import React from 'react';
import type { FC } from 'react';
import { Spinner, Alert } from '@wix/cli-ui-kit';
import type { TaskStatus } from '../task-runner.js';

export const TaskList: FC<{
  tasks: TaskStatus[];
  totalTaskCount: number;
}> = ({ tasks, totalTaskCount }) => {
  return (
    <>
      {tasks.map((task, index) => {
        const stepper = `[${index + 1}/${totalTaskCount}]`;
        const fullText = `${stepper} ${task.text}`;
        if (task.status === 'running') {
          return <Spinner key={index} text={fullText} />;
        }

        return (
          <Alert key={index} type="success">
            {fullText}
          </Alert>
        );
      })}
    </>
  );
};
